import { render } from "./PersonalHeader.vue?vue&type=template&id=184f970d&scoped=true"
import script from "./PersonalHeader.vue?vue&type=script&lang=js"
export * from "./PersonalHeader.vue?vue&type=script&lang=js"

import "./PersonalHeader.vue?vue&type=style&index=0&id=184f970d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184f970d"]])

export default __exports__